// TODO: Add image alt tag.
/* eslint-disable jsx-a11y/alt-text */
import { Trans } from 'react-i18next';
import { PageComponent } from '@root/pages/Type';
import React from 'react';
import { nanoid } from 'nanoid';
import classnames from 'classnames';
import styles from './HardwareSection.module.scss';
import Carousel, { Slide } from './Carousel';

const HardwareSection: PageComponent = () => {
    return (
        <section className={styles.section_hardware}>
            <h1 className={styles.title}>
                <Trans
                    i18nKey="hardware.title"
                    ns="landingFeaturesReasonsTechnology"
                >
                    Techninė įranga
                </Trans>
            </h1>
            <p className={styles.desc}>
                <Trans
                    i18nKey="hardware.description"
                    ns="landingFeaturesReasonsTechnology"
                >
                    Naudojame tik pasaulyje pripažintų lyderių technine įrangą.
                </Trans>
            </p>
            <Carousel className={classnames(styles.logo_container)}>
                <Slide
                    index={nanoid()}
                    src="/static/img/brands/dell.svg"
                    alt="dell"
                />
                <Slide
                    index={nanoid()}
                    src="/static/img/brands/juniper.svg"
                    alt="Juniper"
                />
                <Slide
                    index={nanoid()}
                    src="/static/img/brands/cisco.svg"
                    alt="cisco"
                />
                <Slide
                    index={nanoid()}
                    src="/static/img/brands/amd.svg"
                    alt="AMD"
                />
                <Slide
                    index={nanoid()}
                    src="/static/img/brands/intel.svg"
                    alt="intel"
                />
                <Slide
                    index={nanoid()}
                    src="/static/img/brands/hp.svg"
                    alt="hp"
                />
                <Slide
                    index={nanoid()}
                    src="/static/img/brands/apc.svg"
                    alt="apc"
                />
            </Carousel>
        </section>
    );
};

export default HardwareSection;
